const costEndpoint = `${process.env.VUE_APP_URL}/api/v1/cost/`;
// cost pools are using mixins
export default {
  namespaced: true,
  state: {
    hasTdabcDriver:false,
  },
  mutations: {
    SET_HAS_TDABC_DRIVER(state, data){
        state.hasTdabcDriver=data
    },
  },
  actions: {
  },
}
